import { Record } from '@common/data-models/records/record';
import { ObjectTypes } from "@common/enums/object-types";
import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";

export type PublicationChannelType = "Email" | "CMS" | "Social" | "Broadcast";
export type PublicationChannelSchedule = "Hourly" | "Daily" | "Weekly" | "On Demand";

export class PublicationChannelRecord extends Record {

    public initialize() {
        this.type = ObjectTypes.PUBLICATION_CHANNEL;
    }

    public get channelType(): PublicationChannelType { return this.getAs<PublicationChannelType>(PSTFieldNames.PSTPublicationChannelType); }
    public set channelType(value: PublicationChannelType) { this.set(PSTFieldNames.PSTPublicationChannelType, value); }

    public get channelSchedule(): PublicationChannelSchedule { return this.getAs<PublicationChannelSchedule>(PSTFieldNames.PSTPublicationChannelSchedule); }
    public set channelSchedule(value: PublicationChannelSchedule) { this.set(PSTFieldNames.PSTPublicationChannelSchedule, value); }

    public get channelSections(): string { return this.getAs<string>(PSTFieldNames.PSTPublicationChannelSections); }
    public set channelSections(value: string) { this.set(PSTFieldNames.PSTPublicationChannelSections, value); }

    public get channelRevisions(): boolean { return this.getAs<boolean>(PSTFieldNames.PSTPublicationChannelRevisions); }
    public set channelRevisions(value: boolean) { this.set(PSTFieldNames.PSTPublicationChannelRevisions, value); }

    public get channelActionID(): string { return this.getAs<string>(PSTFieldNames.PSTPublicationChannelActionID); }
    public set channelActionID(value: string) { this.set(PSTFieldNames.PSTPublicationChannelActionID, value); }

    public get editionNames(): string { return this.getAs<string>(PSTFieldNames.PSTPublicationChannelEditionNames); }
    public set editionNames(value: string) { this.set(PSTFieldNames.PSTPublicationChannelEditionNames, value); }

    public get sectionsList(): Array<string> {
        if (this.channelSections == null) {
            return [];
        }
        this.channelSections = this.channelSections.trim();
        if (this.channelSections.endsWith("|")) {
            this.channelSections = this.channelSections.substring(0, this.channelSections.length - 1);
        }
        if (this.channelSections.startsWith("|")) {
            this.channelSections = this.channelSections.substring(1);
        }
        return this.channelSections.split("|").map((item: string) => {
            return item.trim();
        });
    }

    public get editionsList(): Array<string> {
        if (this.editionNames == null) {
            return [];
        }
        this.editionNames = this.editionNames.trim();
        if (this.editionNames.endsWith("|")) {
            this.editionNames = this.editionNames.substring(0, this.editionNames.length - 1);
        }
        if (this.editionNames.startsWith("|")) {
            this.editionNames = this.editionNames.substring(1);
        }
        return this.editionNames.split("|").map((item: string) => {
            return item.trim();
        });
    }
}
